import { useI18n } from '@/context/I18nContext';
import { CrudPage, type CrudColumn, type CrudField } from '@/components/crud/CrudPage';

interface Hub {
  id: string;
  brand: string;
  type: string;
  width?: string;
  position?: string;
  teamId: string;
}

export function HubsTab({ teamId, readOnly }: { teamId: string; readOnly?: boolean }) {
  const { t } = useI18n();

  const columns: CrudColumn<Hub>[] = [
    { key: 'brand', label: t('common.brand') },
    {
      key: 'type',
      label: t('common.type'),
      render: (e) => (
        <span className="inline-block px-2.5 py-0.5 bg-accent-subtle border border-accent/20 rounded-full text-xs font-medium text-accent-hover tracking-wide">
          {e.type}
        </span>
      ),
    },
    {
      key: 'width',
      label: t('common.width'),
      className: 'w-[100px] text-text-secondary text-sm',
      render: (e) => e.width || <span className="text-text-muted">—</span>,
    },
    {
      key: 'position',
      label: t('common.position'),
      className: 'w-[100px] text-text-secondary text-sm',
      render: (e) => e.position ? t(`materials.position.${String(e.position).toLowerCase()}` as any) : <span className="text-text-muted">—</span>,
    },
  ];

  const fields: CrudField[] = [
    { key: 'brand', label: t('common.brand'), placeholder: 'e.g. OTK' },
    { key: 'type', label: t('common.type'), placeholder: 'e.g. Magnesium' },
    { key: 'width', label: t('common.width'), placeholder: 'e.g. 90mm', optional: true },
    { 
      key: 'position', 
      label: t('common.position'), 
      type: 'select',
      placeholder: t('common.none'),
      options: [
        { value: 'front', label: t('materials.position.front') },
        { value: 'rear', label: t('materials.position.rear') },
      ],
    },
  ];

  return (
    <CrudPage<Hub>
      title={t('materials.tab.hubs')}
      entityName={t('materials.entity.hub')}
      emptyIcon="🔧"
      columns={columns}
      fields={fields}
      listMethod="ListHubs"
      createMethod="CreateHub"
      updateMethod="UpdateHub"
      deleteMethod="DeleteHub"
      listParams={{ teamId }}
      readOnly={readOnly}
      hiddenValues={{ teamId }}
    />
  );
}
